import { GET_PIE_ANALYSIS_CALCULATION, RESET_GET_PIE_ANALYSIS_CALCULATION } from "../../actionTypes/actionsTypes";
import defaultAsyncReducerWithReset from "../../defaultReducerReset";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface getPIEAnalysisCalculationState extends BaseAsyncReducerState {
    snapshotId?: number
}

const initialState: getPIEAnalysisCalculationState = {
    loading: false,
    error: false
}

function getPIEAnalysisCalculationReducer(state = initialState, action: AppAction) {
    return defaultAsyncReducerWithReset(state, action as AppAction, GET_PIE_ANALYSIS_CALCULATION, RESET_GET_PIE_ANALYSIS_CALCULATION, initialState)
}

export default getPIEAnalysisCalculationReducer;